// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"c1-z"};